import { gql } from '@apollo/client';

const ProjectFields = gql`
  fragment ProjectFields on ProjectFieldDTO {
    __typename
    fieldId
    name
    type
    jsonFieldSettings
  }
`;

export default ProjectFields;
